<ion-row
  class="sis-tenant-title-small"
  [ngStyle]="
    mobileStyleTenant
      ? {
          color: config?.tenantTitleColor,
          background: config?.tenantColor,
        }
      : {}
  "
>
<ion-col>
  {{ tenantAlias }}
</ion-col>
</ion-row>

@for (weatherStation of weatherStations; track trackByGuid($index, weatherStation)) {
  <ion-grid
    [ngClass]="mobileStyleTenant ? 'sis-webreport-meteo-grid-tenant-style' : 'sis-webreport-meteo-grid-sisag-style'"
    >
    <ion-row
      class="sis-webreport-meteo-station-row"
    [ngClass]="
      mobileStyleTenant ? 'sis-webreport-meteo-station-row-tenant-style' : 'sis-webreport-meteo-station-row-sisag-style'
    "
      style="margin-bottom: 10px; height: 45px"
      >
      <ion-col size="10" style="align-content: center">
        <span style="font-size: 20px">{{ weatherStation.location }}</span>
        <span style="margin-left: 15px">{{
          weatherStation.altitude.slice(0, -1) + ' ' + ('webreport.term.metersAboveSeaLevel' | translate)
        }}</span>
      </ion-col>
      @if (showWeather) {
        <ion-col size="2" style="align-content: center">
          @if (weatherStation.weather) {
            <ion-img
              class="sis-webreport-meteo-mobile-image"
        [src]="
          mobileStyleTenant
            ? 'assets/icons-meteo/desktop/' + weatherStation.weather + '.svg'
            : 'assets/icons-meteo/mobile/' + weatherStation.weather + '.svg'
        "
            ></ion-img>
          }
        </ion-col>
      }
    </ion-row>
    @if (showTemperature && weatherStation.temperature !== null && weatherStation.temperature !== undefined) {
      <ion-row
        class="sis-webreport-meteo-station-row"
        >
        <ion-col>
          {{ 'webreport.term.temperature' | translate }}
        </ion-col>
        <ion-col>
          {{ weatherStation.temperature + ' °C' }}
        </ion-col>
      </ion-row>
    }
    @if (showSnowCondition && weatherStation.snowConditionId !== 0) {
      <ion-row class="sis-webreport-meteo-station-row">
        <ion-col>
          {{ 'webreport.term.snowCondition' | translate }}
        </ion-col>
        <ion-col>
          {{ getSnowConditionTranslationString(weatherStation.snowConditionId) | translate }}
        </ion-col>
      </ion-row>
    }
    @if (showSlopeCondition && weatherStation.slopeConditionId !== 0) {
      <ion-row class="sis-webreport-meteo-station-row">
        <ion-col>
          {{ 'webreport.term.slopeCondition' | translate }}
        </ion-col>
        <ion-col>
          {{ getSlopeConditionTranslationString(weatherStation.slopeConditionId) | translate }}
        </ion-col>
      </ion-row>
    }
    @if (showFreshSnow) {
      <ion-row class="sis-webreport-meteo-station-row">
        <ion-col>
          {{ 'webreport.term.freshSnow' | translate }}
        </ion-col>
        <ion-col>
          {{ weatherStation.freshSnow + ' cm' }}
        </ion-col>
      </ion-row>
    }
    @if (showSnowDepth) {
      <ion-row class="sis-webreport-meteo-station-row">
        <ion-col>
          {{ 'webreport.term.snowDepth' | translate }}
        </ion-col>
        <ion-col>
          {{ weatherStation.snowDepth + ' cm' }}
        </ion-col>
      </ion-row>
    }
    @if (showlatestSnowfall) {
      <ion-row class="sis-webreport-meteo-station-row">
        <ion-col>
          {{ 'webreport.term.latestSnowfall' | translate }}
        </ion-col>
        <ion-col>
          {{ weatherStation.latestSnowfall }}
        </ion-col>
      </ion-row>
    }
    @if (showAvalancheDangerLevel) {
      <ion-row class="sis-webreport-meteo-station-row">
        <ion-col>
          {{ 'webreport.term.avalancheDangerLevel' | translate }}
        </ion-col>
        <ion-col>
          {{ getAvalancheDangerLevelTranslationString(weatherStation.avalancheDangerLevel) | translate }}
        </ion-col>
      </ion-row>
    }
  </ion-grid>
}
